/*----------------------------------------------------

	portfolio.js

----------------------------------------------------*/


// A. ajax paging
// -----------------------------------------------------------------------------------

function portfolioClicks(){
  document.querySelectorAll('.paging a, .portfolio__nav').forEach(function(item){
    item.addEventListener('click', function(e){
      e.preventDefault();
      getPortfolio(item);
    });
  });
}

portfolioClicks();



function getPortfolio(item){

  var destination = item.getAttribute('href');
  var paging_num = item.innerHTML;
  destination = (destination.endsWith('.html')) ? destination + '?ajax=true' : destination;
  destination = (destination.indexOf('?') >= 0) ? destination.replace('#','&ajax=true#') : destination.replace('#','?ajax=true#');

  var portfolio_list = document.querySelector('.boxgrid');
  var portfolio_tab = document.querySelector('.portfolio__nav');
  var paging = document.querySelector('.paging');

  portfolio_list.style.height = portfolio_list.clientHeight;
  portfolio_list.style.display = 'none';

  portfolio_list.innerHTML = '';

  var xhr  = new XMLHttpRequest()
  xhr .onreadystatechange = function(){
    if(xhr.readyState == XMLHttpRequest.DONE){
      if(xhr.status == 200){

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Pageview',
          'url': destination
        });

        var data = xhr.responseText;

        tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;

        var new_list = tempDiv.querySelector('.boxgrid');
        var new_paging = tempDiv.querySelector('.paging');

        portfolio_list.parentNode.replaceChild(new_list, portfolio_list);

        paging.innerHTML = new_paging.innerHTML;


        if(portfolio_tab){
          portfolio_tab.parentNode.replaceChild(tempDiv.querySelector('.portfolio__nav'), portfolio_tab);
        }


        // save current page number to 
        const currentUrl = window.location.href.split('#')[0];
        const cookieData = JSON.stringify([currentUrl, paging_num]);
        console.log(cookieData);
        setPortfolioCookie('portfolio-view',cookieData,1);

        portfolioClicks();

      }
    }
  }
  xhr.open('GET', destination);
  xhr.send();

}




// B. minifolio
// -----------------------------------------------------------------------------------

var features = document.querySelectorAll('[data-feature="ecommerce"],[data-feature="cms"]');

if(window.matchMedia("(min-width:620px)").matches && features){

  features.forEach(function(item){

    item.classList.add('icon-sections__wide', 'minifolio--wrap'); // make full width
    wrapInner(item,'div');
    item.querySelector('div').classList.add('icon-sections__wide__inner');

    var destination = '/include/functions.php?minifolio=' + item.getAttribute('data-feature');
    var btn = item.querySelector('.btn').parentNode;

    var xhr  = new XMLHttpRequest()
    xhr .onreadystatechange = function(){
      if(xhr.readyState == XMLHttpRequest.DONE){
        if(xhr.status == 200){

          var data = xhr.responseText;
          var fi = btn.closest('.icon-sections__wide__inner');

          var minifolio = document.createElement('div');
          minifolio.setAttribute('class','minifolio');
          minifolio.innerHTML = data;

          fi.after(minifolio);
          btn.parentNode.removeChild(btn);

        }
      }
    }
    xhr.open('GET', destination);
    xhr.send();

  });

}

// cookies
function setPortfolioCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
